// Built-in academic programs, shown on the Home and Academics pages until an
// admin saves their own list from Settings → Programs. The admin editor starts
// from this same list, so what the admin edits matches what the site shows.
// No `_id`s here — MongoDB assigns them when the list is first saved.
export const DEFAULT_PROGRAMS = [
  {
    title: "Montessori / Pre-Primary",
    grades: "Play Group - UKG",
    age: "Age: ~2.5 – 5 years",
    colorScheme: "blue",
    subjects: [
      "Play Group (PG)",
      "Nursery",
      "Lower Kindergarten (LKG)",
      "Upper Kindergarten (UKG)",
    ],
    description:
      "Our Pre-Primary program focuses on basic learning, play, and behavior to build a strong early foundation for young minds.",
    highlights: [
      "Play-based learning environment",
      "Focus on basic behavior and socialization",
      "Interactive games and storytelling",
      "Caring and trained Montessori teachers",
    ],
  },
  {
    title: "Primary Level",
    grades: "Class 1 - 5",
    age: "Age: ~6 – 10 years",
    colorScheme: "primary",
    subjects: [
      "Class 1",
      "Class 2",
      "Class 3",
      "Class 4",
      "Class 5",
      "Mathematics",
      "English",
      "Science",
    ],
    description:
      "Dedicated to foundational knowledge and mastery of basic core subjects like Math, English, and Science.",
    highlights: [
      "Strong foundation in basic subjects",
      "Regular assessments and progress tracking",
      "Focus on reading and writing skills",
      "Extracurricular activities integration",
    ],
  },
  {
    title: "Lower Secondary Level",
    grades: "Class 6 - 8",
    age: "Age: ~11 – 13 years",
    colorScheme: "secondary",
    subjects: [
      "Class 6",
      "Class 7",
      "Class 8",
      "Advanced Math",
      "General Science",
      "Social Studies",
    ],
    description:
      "Designed for concept building, critical thinking, and introduction to more advanced subjects bridging primary and high school.",
    highlights: [
      "Concept building methodologies",
      "Introduction to advanced subjects",
      "Critical thinking and problem solving",
      "Project-based learning",
    ],
  },
  {
    title: "Secondary Level",
    grades: "Class 9 - 10",
    age: "Age: ~14 – 16 years",
    colorScheme: "primary",
    subjects: [
      "Class 9",
      "Class 10",
      "Compulsory Math",
      "Optional Math",
      "Science",
      "English",
    ],
    description:
      "Rigorous academic preparation focusing on the SEE (School Leaving Certificate) under the National Examination Board.",
    highlights: [
      "SEE Board Exam preparation",
      "Comprehensive syllabus coverage",
      "Mock tests and revision classes",
      "Career counseling for higher education",
    ],
  },
];
